import React from "react";
import { Flex } from "@fluentui/react-northstar";
import Header from "./components/Header";
import Content from "./components/content";
import withAuth from "../../HOC/withAuth";

const HrDocuments = () => {
    return (
        <Flex
            column
            styles={{
                backgroundColor: "#f5f5f5",
                flex: 1,
                paddingTop: "20px",
            }}
        >
            <Flex column gap="gap.medium">
                <Header />
                <Content />
            </Flex>
        </Flex>
    );
};

export default withAuth(HrDocuments);
